import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirebaseService } from 'src/app/shared/firebase.service';
import { ControlService } from 'src/app/shared/control.service';

@Component({
  selector: 'app-gameover',
  templateUrl: './gameover.component.html',
  styleUrls: ['./gameover.component.scss']
})
export class GameoverComponent implements OnInit {

  constructor(
    private router: Router,
    private fireBaseService: FirebaseService,
    private controlService: ControlService,
  ) { }

  ngOnInit(): void {
  }

  toStart(): void {
    this.controlService.failedCounter.next(0);
    this.fireBaseService.collection = [];
    this.router.navigate(['/']);
  }

  restart(): void {
    this.controlService.failedCounter.next(0);
    this.fireBaseService.collection = [];
    this.router.navigate(['/', 'collections']);
  }

}
